import React from 'react';

function ActiveRatingStarIcon(props) {
  return (
    <svg width='17px' height='16px' viewBox='0 0 17 16' version='1.1' xmlns='http://www.w3.org/2000/svg' {... props}>
      <defs>
          <path d="M12.8599093,15.8942857 L8.36,12.6217143 L3.86009067,15.8948571 C3.66390933,16.0377143 3.399176,16.0348571 3.20633867,15.888 C3.01238667,15.7405714 2.93324533,15.4828571 3.00904267,15.2485714 L4.72061333,9.97485714 L0.234637333,6.712 C0.0373413333,6.568 -0.0473733333,6.30971429 0.0261946667,6.07257143 C0.10032,5.83542857 0.314336,5.67485714 0.557333333,5.67485714 L6.11673333,5.67485714 L7.83109067,0.391428571 C7.90744533,0.157142857 8.11978933,0 8.36,0 C8.60021067,0 8.813112,0.157142857 8.88890933,0.391428571 L10.6032667,5.67485714 L16.1626667,5.67485714 C16.405664,5.67485714 16.61968,5.83542857 16.6938053,6.07257143 C16.7673733,6.30971429 16.6826587,6.568 16.4853627,6.712 C16.4853627,6.712 14.1436356,8.41524601 12.9727721,9.26686902 C12.6483103,9.50286506 11.9993867,9.97485714 11.9993867,9.97485714 L13.7109573,15.2485714 C13.7867547,15.4828571 13.707056,15.7405714 13.5136613,15.888 C13.4155707,15.9628571 13.2985307,16 13.182048,16 C13.0694667,16 12.956328,15.9645714 12.8599093,15.8942857 Z" id="path-1"></path>
          <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-2">
              <feGaussianBlur stdDeviation="0.75" in="SourceAlpha" result="shadowBlurInner1"></feGaussianBlur>
              <feOffset dx="0" dy="0" in="shadowBlurInner1" result="shadowOffsetInner1"></feOffset>
              <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
              <feColorMatrix values="0 0 0 0 0.961710989   0 0 0 0 0.65036732   0 0 0 0 0.138542295  0 0 0 1 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
          </filter>
      </defs>
      <g id="97---Applicant-Interview--Ratings-by-QS" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="97---Applicant-Interview--Ratings-by-QS-3" transform="translate(-617.000000, -442.000000)">
              <g id="icon_song-favorites-copy-4" transform="translate(617.000000, 442.000000)">
                  <g id="Icons">
                      <g id="Shape">
                          <use fill="#FFE40A" fillRule="evenodd" xlinkHref="#path-1"></use>
                      </g>
                  </g>
              </g>
          </g>
      </g>
</svg>
  );
}

export default ActiveRatingStarIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/ActiveRatingStar.js